var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defaultDiv"},[_c('comerr',{attrs:{"err":_vm.err,"url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }